import { postData } from "@/lib/request";

export const LoginApi = (username, password) =>
  postData("/web/auth/login", { username, password });
